<template>
  <div class="card width-535">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content columns is-marginless is-multiline">
      <section class="has-text-centered column is-12">
          <span class="is-size-3 has-text-weight-bold">
            {{ $t('general.popUpEdition.title') }}
          </span>
      </section>
      <div class="column is-12 is-paddingless mgt-20px">
      <error-msg-component :messages="error.messages"
                           :error="error.haveError"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           :messagesChampsVide="error.messagesChampsVide"
                           :champsVide="error.champsVide"
                           @close="error.haveError = $event"/>
    </div>
      <div class="column is-12 is-paddingless mgt-20px" v-if="choiceEdition.length > 0">
        <b-select v-model="selectEdition" expanded @input="initialiseExtra()">
          <option
            v-for="(edition, $index) in choiceEdition"
            :key="$index"
            :value="edition">
            {{ $t(edition.libelle) }}
          </option>
        </b-select>
      </div>
      <div class="column is-12 is-paddingless mgt-20px" v-if="aChampExtra">
        <b-field :label="$t(selectEdition.extra.libelle)"
          :class="{'obligatoire': selectEdition.extra.obligatoire}">
            <b-input v-if="selectEdition.extra.type !== 'boolean'"
              :type="selectEdition.extra.type" ref="input"
              v-model="selectEdition.parametresAdditionnels[selectEdition.extra.param]">
            </b-input>
            <qd-switch v-else ref="inputSwitch"
              v-model="selectEdition.parametresAdditionnels[selectEdition.extra.param]">
            </qd-switch>
        </b-field>
      </div>
      <div class="column is-12 columns is-paddingless mgt-20px mgr-0 is-flex-grow-1"
        v-if="filtreDates && selectEdition !== null && selectEdition.tousProduits">
        <div class="column is-6">
          <b-field :label="$t('listeProduitReseauTempo.popUpEditionPlanning.dateDebut')"
                   :class="{'obligatoire' : isFilterDateMandatory }">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          icon="calendar-today"
                          v-model="dateDebut"
                          :max-date="dateFin"
                          :editable="true"
                          expanded>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6 mgl-3">
          <b-field :label="$t('listeProduitReseauTempo.popUpEditionPlanning.dateFin')"
                   :class="{'obligatoire' : isFilterDateMandatory }">
            <b-datepicker show-week-number
                          nearby-selectable-month-days
                          icon="calendar-today"
                          v-model="dateFin"
                          :min-date="dateDebut"
                          :editable="true"
                          expanded>
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <div class="column is-12 is-paddingless mgt-20px">
        <div>
          <qd-radio v-model="format"
                   :native-value="pdf"
                   :disabled = disabledExtention(pdf)>
            {{ $t('general.popUpEdition.type.pdf') }}
          </qd-radio>
        </div>
        <div class="mgt-10px">
          <qd-radio v-model="format"
                   :native-value="docx"
                   :disabled = disabledExtention(docx)>
            {{ $t('general.popUpEdition.type.docx') }}
          </qd-radio>
        </div>
      </div>
      <main class="column is-12 is-paddingless mgt-20px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered
                  button-modal"
            @click="$parent.close"
            >
            {{ $t('general.popUpEdition.actions.cancel') }}
          </button>
          <b-tooltip :active="!dateDebut || !dateFin"
                     v-if="choiceEdition.length > 0 && isFilterDateMandatory"
                     :label="$t('exportBalanceTiers.errorDates')">
            <button
              class="button is-primary has-text-centered button-modal"
              :class="{'disabledButton': !dateDebut || !dateFin}"
              @click="editionChoose">
              {{ $t('general.popUpEdition.actions.valider') }}
            </button>
          </b-tooltip>
          <button v-else-if="choiceEdition.length > 0"
            class="button is-primary has-text-centered button-modal"
            @click="editionChoose"
          >
            {{ $t('general.popUpEdition.actions.valider') }}
          </button>
          <button v-else
                  class="button is-primary has-text-centered button-modal"
                  @click="$emit('editionChoose', format)"
          >
            {{ $t('general.popUpEdition.actions.valider') }}
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    choiceEdition: {
      type: Array,
      required: true,
    },
    error: {
      type: Object,
      required: true,
    },
    filtreDates: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      selectEdition: null,
      format: TYPE_PDF,
      pdf: TYPE_PDF,
      docx: TYPE_DOCX,
      affExtra: false,
      dateDebut: null,
      dateFin: null,
    };
  },
  computed: {
    aChampExtra() {
      return (this.selectEdition != null
      && this.selectEdition.extra
      && this.selectEdition.extra.param
      && this.selectEdition.parametresAdditionnels
      && this.affExtra);
    },
    isFilterDateMandatory() {
      return this.filtreDates && this.selectEdition?.hasMandatoryDates;
    },
  },
  methods: {
    disabledExtention(typeExtention) {
      return (this.selectEdition != null
       && this.selectEdition.extentions != null
       && !this.selectEdition.extentions.includes(typeExtention));
    },
    initialiseExtra() {
      this.affExtra = false;
      if (!this.selectEdition.extra || !this.selectEdition.extra.param) return;
      if (!this.selectEdition.parametresAdditionnels) {
        this.selectEdition.parametresAdditionnels = {};
      }
      this.selectEdition.parametresAdditionnels[this.selectEdition.extra.param] = null;
      if (this.selectEdition.extra.type === 'boolean') {
        this.selectEdition.parametresAdditionnels[this.selectEdition.extra.param] = false;
      }
      if (this.$refs.input) {
        this.$refs.input.updateValue(null);
      }
      if (this.$refs.inputSwitch) {
        this.$refs.inputSwitch.newValue = false;
      }
      this.affExtra = true;
    },
    editionChoose() {
      const editionInput = {
        typeDonnee: this.selectEdition.typeDonnee,
        format: this.format,
        typeEdition: this.selectEdition.typeEdition,
        parametresAdditionnels: this.selectEdition.parametresAdditionnels,
      };
      if (this.dateDebut && this.filtreDates) {
        if (!editionInput.parametresAdditionnels) editionInput.parametresAdditionnels = {};
        editionInput.parametresAdditionnels.dateDebut = formatDate(this.dateDebut);
        editionInput.parametresAdditionnels.dateFin = formatDate(this.dateFin);
      }
      this.$emit('editionChoose', editionInput);
    },
  },
  components: {
    errorMsgComponent,
  },
  beforeMount() {
    if (Object.keys(this.error).length > 0) {
      this.error.haveError = false;
      this.error.messages = [];
      this.error.messagesChampsVide = [];
      this.error.champsVide = [];
    }
  },
  mounted() {
    if (this.choiceEdition && this.choiceEdition.length >= 1) {
      this.selectEdition = this.choiceEdition[0];
      this.initialiseExtra();
      this.dateDebut = (moment().startOf('year')).toDate();
      this.dateFin = (moment().endOf('year')).toDate();
    }
  },
};

</script>
